(function(){
    'use strict';
    angular.module('app').controller('ReminderModalController', ReminderModalController);

    ReminderModalController.$inject = [
        '$uibModalInstance',
        'ViewChangeNotificationFactory',
        'ConfirmationModalFactory',
        'reminder',
        'ComplianceService',
        'compliance',
        'ComplianceConst',
        'FormHelpersService',
        'ObjectHelpersService',
        '$q',
        'toastr'
    ];

    function ReminderModalController(
        $uibModalInstance,
        ViewChangeNotificationFactory,
        ConfirmationModalFactory,
        reminder,
        ComplianceService,
        compliance,
        ComplianceConst,
        FormHelpersService,
        ObjectHelpersService,
        $q,
        toastr
    )  {
        const vm = this;
        vm.onSaveButtonClicked = onSaveButtonClicked;
        vm.onCancelButtonClicked = onCancelButtonClicked;
        vm.changeStatus = changeStatus;
        vm.onSearchTriggers = onSearchTriggers;

        const toInactiveConf = new ConfirmationModalFactory({},{
            message: 'messages.warning.statusChange.MESSAGE.TO_RECORD_INACTIVE',
            code: 'messages.warning.statusChange.CODE'
        });

        const toActiveConf = new ConfirmationModalFactory({},{
            message: 'messages.warning.statusChange.MESSAGE.TO_RECORD_ACTIVE',
            code: 'messages.warning.statusChange.CODE'
        });

        function showToActiveConfirmation() {
            vm.reminder.active = false;
            toActiveConf.getInstance().result.then(function (cond) {
                if (cond) vm.reminder.active = true;
            });
        }

        function showToInActiveConfirmation() {
            vm.reminder.active = true;
            toInactiveConf.getInstance().result.then(function (cond) {
                if (cond) vm.reminder.active = false;
            });
        }

        function changeStatus(evt) {
            evt.preventDefault();
            if(vm.reminder.active){
                showToActiveConfirmation();
            } else {
                showToInActiveConfirmation();
            }
        }

        function getTriggersData(search) {
            const defer = $q.defer();
            ComplianceService.triggers.getAll(compliance.id, data => {
                defer.resolve(data.content);
            }, err =>  {
                toastr.error('Unable to search for triggers', err.message)
                defer.reject(err);
            }, {
                name: search
            });
        }

        function passTriggersDataToView(data) {
            vm.triggers = data;
        }

        function onSearchTriggers(select) {
            if(!select.open){
                return false;
            }
            const {search} = select;
            getTriggersData(search).then(data => {
                passTriggersDataToView(data);
            });
        }

        function closeModal() {
            $uibModalInstance.dismiss();
        }

        function onCancelButtonClicked() {
            closeModal();
        }

        function generatePayload(reminder) {
           return {
               active: reminder.active || false,
               complianceItemId: compliance.id,
               frequency: reminder.frequency,
               frequencyNumber: reminder.frequencyNumber,
               frequencyUnit: reminder.frequencyUnit,
               message: reminder.message,
               name: reminder.name
           }
        }

        function createNewReminder() {
            const defer = $q.defer();
            vm.savingData = true;
            ComplianceService.reminders.create(data => {
                vm.savingData = false;
                defer.resolve(data);
            }, error => {
                toastr.error('Unable to crete reminder', error.message);
                vm.savingData = false;
                defer.reject(error);
            }, generatePayload(vm.reminder));
            return defer.promise;
        }

        function updateReminder(){
            const defer = $q.defer();
            ComplianceService.reminders.update(data => {
                vm.savingData = false;
                defer.resolve(data);
            }, error => {
                toastr.error('Unable to crate reminder', error.message);
                vm.savingData = false;
                defer.reject(error);
            }, vm.reminder.id, generatePayload(vm.reminder));
            return defer.promise;
        }

        function isReminderOriginalDataSet() {
            return ObjectHelpersService.isObjectEmpty(vm.reminderRaw);
        }

        function saveReminderData() {
            if (isReminderOriginalDataSet()) {
                createNewReminder().then(data => {
                    toastr.success('Reminder Saved');
                    $uibModalInstance.close(data);
                });
            } else {
                updateReminder().then(data => {
                    toastr.success('Reminder Updated');
                    $uibModalInstance.close(data);
                });
            }
        }

        function validateForms(forms) {
            FormHelpersService.setFormsToSubmitted(forms);
            return FormHelpersService.getInvalidForms(forms);
        }

        function onSaveButtonClicked(...forms) {
            const invalidForms = validateForms(forms);
            if(invalidForms.length !== 0){ return false; }
            saveReminderData();
        }

        function passReminderDataToView() {
            vm.reminder = reminder;
        }

        function setOriginalCopyOfTheReminderData() {
            vm.reminderRaw = angular.copy(reminder);
        }

        function passFrequenciesDataToView() {
            vm.frequencies = ComplianceConst.frequencies;
        }

        function passFrequencyUnitsDataToView() {
            vm.frequencyUnits = ComplianceConst.units;
        }

        function init(){
            passReminderDataToView();
            setOriginalCopyOfTheReminderData();
            passFrequenciesDataToView();
            passFrequencyUnitsDataToView();
        }

        init();
    }
})();



// WEBPACK FOOTER //
// ./js/controllers/compliance/modals/ReminderModalController.js